












import { Prop, Component, Vue } from 'vue-property-decorator'
import { ReferralNode } from '@/api/model/referral-node'
import { Dictionary } from 'lodash'

enum Direction {
    INCOMING = 'incoming',
    OUTGOING = 'outgoing',
}

@Component
export default class ListReferralNodes extends Vue {
    @Prop() group!: Dictionary<ReferralNode[]>
    @Prop() direction!: Direction

    orderReferralNodesByType(value: ReferralNode[]) {
        return value.sort((a, b) =>
            this.$t(`referral.type.${a.type}`).toString().localeCompare(
                this.$t(`referral.type.${b.type}`).toString(),
            ),
        )
    }

    routeToEdit(referralNodeId: string) {
        return {
            name: `company_settings_sources_edit_${this.direction}`,
            params: {
                referralNodeId,
            },
        }
    }
}
